(() => {
  const forms = document.querySelectorAll('[data-namski-society-form]');

  forms.forEach((form) => {
    if (form.dataset.namskiSocietyReady === 'true') return;
    form.dataset.namskiSocietyReady = 'true';

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const input = form.querySelector('[data-namski-society-password]');
      const error = form.parentElement?.querySelector('[data-namski-society-error]');

      if (input) input.value = '';
      if (error) error.hidden = false;
      input?.focus();
    });
  });
})();
